module.exports = __webpack_public_path__ + "static/disabled-access-coach-yutong-b7e40c9cc58fa46d4b58ea641a1cc600.jpg";